function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2570.78 -2844.795)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12.383,
  cy: 12.383,
  r: 12.383,
  transform: "translate(2570.78 2844.795)",
  fill: "#f15a24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2590.275,2851.443h-2.058l.257-1.8h-4.5v-1.8h-1.8v1.8h-4.5l1.8,12.606h2.7v1.8h-2.7v1.8h7.2v-1.8h-2.7v-1.8h2.7l.257-1.8h3.344l1.8-9Zm-9.261,9-1.287-9h6.689l-1.286,9Zm6.174-1.8.772-5.4h1.955l-1.08,5.4Z",
  fill: "#b40000"
}));

var SvgThirdPlace = function SvgThirdPlace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.766,
    height: 24.766,
    viewBox: "0 0 24.766 24.766",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThirdPlace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/third-place.99ba9aa1.svg";
export { ForwardRef as ReactComponent };